// Port of api/fuel/app/classes/filter/search/games/filters/query/other/subdomains.php
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	name: 'other.subdomains',
	priority: 77,
	require: function(config, filter) { return filter.subdomains && filter.subdomains.length > 0 },
	run: function(config, filter, data, query) {
		var include = [], exclude = []
		for (var i = 0; i < filter.subdomains.length; i++) {
			var s = filter.subdomains[i]
			if (s < 0) exclude.push(-s)
			else include.push(s)
		}
		if (include.length) {
			var games = DB.query('SELECT DISTINCT game_id AS g FROM game_subdomain WHERE subdomain_id IN(' + Util.in(include) + ')')
			var ids = Util.pluck(games, 'g')
			if (ids.length) query.where('g.game_id', 'in', ids)
			else query.where('g.game_id', '=', 0)
		}
		if (exclude.length) {
			var exGames = DB.query('SELECT DISTINCT game_id AS g FROM game_subdomain WHERE subdomain_id IN(' + Util.in(exclude) + ')')
			var exIds = Util.pluck(exGames, 'g')
			if (exIds.length) query.where('g.game_id', 'not in', exIds)
		}
	}
}
